import { defineComponent } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import router from '@/router';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'NoChannels',
    components: {
        Button,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { currentStep } = storeToRefs(transactionsStore);
        const goBack = () => {
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        const goHome = () => {
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
            router.push('/');
        };
        const onKeyPress = () => console.log('');
        return {
            goBack,
            onKeyPress,
            goHome,
        };
    },
});
